var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((this.items),function(item,index){return _c('div',{key:index},[_c('span',[_vm._v(" "+_vm._s(_vm.attachments[item.id])+" x "+_vm._s(item.number))]),(item.icon)?_c('span',[_vm._v("  (图标："+_vm._s(item.icon)+")")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }